export enum AppLanguage {
  en = 'en_US',
  de = 'de_DE',
  pl = 'pl_PL',
  ru = 'ru_RU',
}

export const appLanguages: AppLanguage[] = [...Object.values(AppLanguage)];
